import { css } from '@emotion/css';

const promotionHomeStyle = {
    wrap: css`
        position: relative;
				justify-content: center;
				.swiper-wrapper {
					display: flex;
					align-items: center;
					padding: 30px 0;
				}
        .swiper-slide {
						transition: transform 0.3s ease, width 0.3s ease;
						padding: 0 3%;
        }
        .swiper-slide-active {
            margin-top: 0;
            transition: 0.15s all ease-out;
						transform: scale(1.6);
						img {
							border-radius: 20px;
						}
        }
    `,
    item: css`
        height: 100%;
        border-radius: 20px;
        /* overflow: hidden; */
    `,
    itemInner: css`
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
    `,
    wrapImg: css`
			cursor: pointer;
			height: 100%;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			img {
					max-width: 100%;
					max-height: 100%;
					border-radius: 20px;
			}
    `,
    btnNavigate: css`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 100px;
    z-index: 2;
    display: flex;
    cursor: pointer;
    background: #FFD9D9;
    &:disabled {
        opacity: 0.5;
        cursor: initial;
    }
    svg {
        polyline {
            stroke: #BC4040;
        }
    }
    `,
    btnPrev: css`
        left: -24px;
    `,
    btnNext: css`
        right: -24px;
    `,
};

export default promotionHomeStyle;
